import React from 'react';
import PropTypes from 'prop-types';
import ComponentLoader from '../../global/ComponentLoader/ComponentLoader';

const importFunc = () => {
    return import(/* webpackChunkName: "PdpRespZoomModal" */
    './PdpRespZoomModal').then(PdpRespZoomModal => PdpRespZoomModal.default);
};

export function PdpRespZoomModalLoader(props) {
    return <ComponentLoader {...props} load={props.isOpen} importFunc={importFunc} />;
}

PdpRespZoomModalLoader.propTypes = {
    isOpen: PropTypes.bool.isRequired,
};

export default PdpRespZoomModalLoader;
